/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {
    console.debug('INFO faq.js loaded')

    let mainEntity = []

    // ITERATE THROUGH ALL CARPOOLDETAILS-COMPONENTS AND INIT THEM
    document.querySelectorAll('[data-script-jsonld]').forEach(function (element) {
        if (element.getAttribute('data-script-jsonld') === 'true') {
            element.querySelectorAll('.c-accordion__header').forEach((accordion) => {
                let question = {
                    '@type': 'Question',
                    name: accordion.getAttribute('data-jsonld-question'),
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: accordion.getAttribute('data-jsonld-answer'),
                    },
                }
                mainEntity.push(question)
            })
        }
    })


    let siblings = (elem) => {
        let siblings = []
        if (!elem.parentNode) {
            return siblings
        }
        let sibling = elem.parentNode.firstElementChild
        do {
            if (sibling != elem) {
                siblings.push(sibling)
            }
        } while (sibling = sibling.nextElementSibling)
        return siblings
    }

    if (mainEntity.length > 0) {
        let json = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: mainEntity,
        }

        let script = document.createElement('script')
        script.type = 'application/ld+json'
        script.innerHTML = JSON.stringify(json)
        document.querySelector('head').appendChild(script)
    }

    document.querySelectorAll("select[name='accordion-selection']").forEach((select) => {
        select.addEventListener('change', (event) => {
            let selector = '#' + event.target.value
            document.querySelectorAll(selector).forEach((selectedAccordion) => {
                siblings(selectedAccordion).forEach((accordion) => {
                    accordion.classList.add('u-hide')
                })
                selectedAccordion.classList.remove('u-hide')
            })
        })
    })

    document.querySelectorAll("select[name='accordion-selection']").forEach((select) => {
        select.dispatchEvent(
            new Event('change', {
                bubbles: true,
                cancelable: true,
            })
        )
    })

})
